import PropTypes from "prop-types";
import React from "react";
import { StyleSheet, View, TouchableOpacity, Dimensions } from "react-native";
import Text from "app/components/Text";
import textHelpers from "app/utils/textHelpers";
import Svg, { Path, Ellipse, Circle, Rect } from "react-native-svg";
import { styleSheet, colors, sizes, screenRatio } from "app/utils/styleSheet";
// import { useHeaderHeight } from '@react-navigation/stack';
import { HeaderHeightContext } from "@react-navigation/stack";

export default class Canvas extends React.Component {
  static propTypes = {
    liens: PropTypes.array,
    scrollHeight: PropTypes.number,
    // onPress: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return null;
    let { lines, scrollHeight } = this.props;

    return (
      <HeaderHeightContext.Consumer>
        {(headerHeight: any) => {
          let windowHeight = Dimensions.get("window").height;
          let scrolling = scrollHeight >= windowHeight;
          let canvasOffset = scrolling ? 0 : -headerHeight;
          let pathOffset = scrolling ? windowHeight - scrollHeight : 0;
          pathOffset = 0;

          let height = Math.max(scrollHeight, windowHeight);

          return (
            <View
              style={{
                ...StyleSheet.absoluteFillObject,
                top: canvasOffset,
                zIndex: -1,
                // borderWidth: 2, borderColor: 'red',
              }}
            >
              <Svg
                height="100%"
                width="100%"
                // viewBox={`0 0 ${Dimensions.get('window').width} ${Dimensions.get('window').height}`}
                viewBox={`0 0 ${Dimensions.get("window").width} ${height}`}
              >
                {lines.map((line, i) => {
                  if (!!line[0][0] && line[0][1] && line[1][0] && line[1][1])
                    return (
                      <Path
                        key={i}
                        d={`M${line[0][0]},${line[0][1] + pathOffset} L${
                          line[1][0]
                        },${line[1][1] + pathOffset}`}
                        stroke={line[0][3] || colors.active}
                        strokeWidth="1.0"
                        strokeDasharray={[`10`, `6.18`]}
                        style={{ opacity: 0.75 }}
                      />
                    );
                })}

                {/*
            <Path d={`M107,154 L448,154`} stroke={'red'} strokeWidth={2} />
            <Path d={`M106,0 L${Dimensions.get('window').width},0 L${Dimensions.get('window').width},500 L0,500`} stroke={'yellow'} strokeWidth={10} />

            A rx ry rotate large_arc_flag sweep_flag x y
            A 50 8 0 0 1 100 10
            C handle1 handl2 endpoint
            C 25,100  150,100  150,50
          */}
                {/*
            <Rect x="0" y="0" width="100" height="100" stroke="blue" strokeWidth="2" fill="yellow" />
            <Path d="M 0 9 
              C 40,6  60,6  100,9
            " stroke="#333" strokeWidth="0.6" strokeDasharray={[`17.6%`, `3%`]} />
            <Path d="M 0 9 
              C 40,6  60,6  100,9
            " stroke="#7a9" strokeWidth="0.4" sstrokeDasharray={[`17.6%`, `3%`]} />
          */}
              </Svg>
            </View>
          );
        }}
      </HeaderHeightContext.Consumer>
    );
  }
}
